// removed by extract-text-webpack-plugin
module.exports = {"ingress":"_2qzYr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Ingress/Ingress.scss
 ** module id = 442
 ** module chunks = 0
 **/